export const scrollToSection = (pos) => {
  window.scrollTo({
    top: pos,
    behavior: "smooth",
  });
};
